// PWA Install Button Component
// Place in: src/components/PWAInstallButton.jsx

import { useState, useEffect } from 'react';

export const PWAInstallButton = () => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [userOS, setUserOS] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(iOS);

    // Detect Android
    const isAndroid = /Android/.test(navigator.userAgent);
    setUserOS(isAndroid ? 'android' : iOS ? 'ios' : 'other');

    // Listen for the beforeinstallprompt event (Android only)
    const handler = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setShowButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // Android: Use the native install prompt
  const handleAndroidInstall = async () => {
    if (!installPrompt) return;

    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;

    if (outcome === 'accepted') {
      setShowButton(false);
      setInstallPrompt(null);
    }
  };

  // iOS: Show instructions for manual install
  const handleIOSInstall = () => {
    alert(
      'To install FINNCAL on your iPhone:\n\n' +
        '1. Tap the Share button (⬆️) at the bottom\n' +
        '2. Scroll and tap "Add to Home Screen"\n' +
        '3. Tap "Add" in the top right\n\n' +
        'FINNCAL will now appear on your home screen!'
    );
  };

  // Only show on mobile
  if (userOS === 'other') return null;

  // Android with install prompt available
  if (userOS === 'android' && showButton) {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '24px',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 4px 6px rgba(99, 102, 241, 0.1)',
          animation: 'slideIn 0.3s ease-out',
        }}
      >
        <div>
          <p style={{ fontWeight: '600', margin: '0 0 4px 0', fontSize: '15px' }}>
            📱 Install FINNCAL
          </p>
          <p style={{ margin: '0', fontSize: '13px', opacity: '0.95' }}>
            Get faster access right on your home screen
          </p>
        </div>
        <button
          onClick={handleAndroidInstall}
          style={{
            background: 'white',
            color: '#6366F1',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '8px',
            fontWeight: '600',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            marginLeft: '16px',
            fontSize: '14px',
            flexShrink: 0,
          }}
        >
          Install
        </button>
        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    );
  }

  // iOS: Show banner with instructions
  if (userOS === 'ios') {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '24px',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 4px 6px rgba(99, 102, 241, 0.1)',
          animation: 'slideIn 0.3s ease-out',
        }}
      >
        <div>
          <p style={{ fontWeight: '600', margin: '0 0 4px 0', fontSize: '15px' }}>
            📱 Install FINNCAL
          </p>
          <p style={{ margin: '0', fontSize: '13px', opacity: '0.95' }}>
            Add to your home screen for quick access
          </p>
        </div>
        <button
          onClick={handleIOSInstall}
          style={{
            background: 'white',
            color: '#6366F1',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '8px',
            fontWeight: '600',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            marginLeft: '16px',
            fontSize: '14px',
            flexShrink: 0,
          }}
        >
          How to
        </button>
        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    );
  }

  return null;
};
